import { useRequest } from "../../../hooks/useRequest";
import { useEffect, useMemo } from "react";
import { SolutionInListApiResponse } from "../types";
import routes from "../../../routes";

function useSolutionList() {
  const { loading, fetch, response, error } = useRequest();

  useEffect(() => {
    fetch("GET", routes.api.solutions.base({}));
  }, [fetch]);

  const solutionList = useMemo<SolutionInListApiResponse[]>(() => {
    if (!response?.data) return [];
    return response.data.map((solution: SolutionInListApiResponse) => ({
      id: solution.id,
      name: solution.name,
      developer: solution.developer,
      shortDescription: solution.shortDescription,
      unitOfSale: solution.unitOfSale,
      country: solution.country,
      coBenefitEducation: solution.coBenefitEducation,
      coBenefitEmployment: solution.coBenefitEmployment,
      isReadyForSale: solution.isReadyForSale,
      isUsedForCarbonOffsetting: solution.isUsedForCarbonOffsetting,
      accountingMethodology: solution.accountingMethodology,
      projectDescriptionDocument: solution.projectDescriptionDocument,
    }));
  }, [response]);

  return {
    loading,
    solutionList,
    error,
  };
}

export default useSolutionList;
